(function () {
  'use strict';

  var STATE_URL = '/apps/smoketo-sub/first-paid-box-state';
  var locked = false;
  var installed = false;

  function addStyles() {
    if (document.getElementById('sk-first-paid-lock-styles')) return;
    var style = document.createElement('style');
    style.id = 'sk-first-paid-lock-styles';
    style.textContent = ''
      + '#sk-first-paid-lock-banner{margin:0 0 20px;padding:14px 16px;border:1px solid #e2ad89;border-radius:12px;background:#fff4ee;color:#553226;font:600 .78rem/1.55 "DM Sans",Arial,sans-serif;}'
      + '#sk-first-paid-lock-banner strong{display:block;margin-bottom:2px;color:#1c1c1c;font-size:.84rem;}'
      + '.sk-paid-locked-control:disabled{opacity:.38!important;cursor:not-allowed!important;transform:none!important;}'
      + '.sk-paid-locked-option,.sk-paid-locked-choice{opacity:.62;}'
      + '.sk-paid-premium-card .sw-upgrade-badge{background:#75665e!important;}'
      + '.sk-paid-inline-note{display:block;margin-top:4px;color:#9a5a38;font-size:.52rem;font-weight:800;line-height:1.25;}'
      + '#sk-addon-paid-lock-note{margin:-6px 0 14px;padding:9px 11px;border-radius:9px;background:#fff4ee;color:#875037;font-size:.66rem;font-weight:700;line-height:1.45;}'
      + '.sk-paid-sidebar-item .sw-sb-rm:disabled{opacity:.28!important;cursor:not-allowed!important;}'
      + '@media(max-width:600px){#sk-first-paid-lock-banner{margin-bottom:14px;padding:12px 13px;font-size:.72rem;}}';
    document.head.appendChild(style);
  }

  function disableButton(button) {
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('title', 'Locked because this box is already paid');
    button.classList.add('sk-paid-locked-control');
  }

  function premiumMealNames() {
    var names = [];
    document.querySelectorAll('#sw-meal-grid .sw-card').forEach(function (card) {
      var badge = card.querySelector('.sw-upgrade-badge:not(.available)');
      if (!badge || !/premium\s*upgrade/i.test(String(badge.textContent || ''))) return;
      var title = card.querySelector('.sw-card-title,.sw-card-name,h3');
      var name = String(title && title.textContent || '').trim();
      if (name && names.indexOf(name) === -1) names.push(name);
    });
    return names;
  }

  function ensureBanner() {
    if (document.getElementById('sk-first-paid-lock-banner')) return;
    var grid = document.getElementById('sw-meal-grid');
    if (!grid || !grid.parentNode) return;
    var banner = document.createElement('div');
    banner.id = 'sk-first-paid-lock-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML = '<strong>Your first box is already paid.</strong>You can still swap included meals before the cutoff above. Premium meals, Double Protein, and extras are locked for this box and become editable with your next weekly box.';
    grid.parentNode.insertBefore(banner, grid);
  }

  function lockPremiumCards() {
    document.querySelectorAll('#sw-meal-grid .sw-card').forEach(function (card) {
      var badge = card.querySelector('.sw-upgrade-badge:not(.available)');
      if (!badge || !/premium\s*upgrade/i.test(String(badge.textContent || ''))) return;
      card.classList.add('sk-paid-premium-card');
      card.querySelectorAll('.sw-add-btn,.sw-qty-btn,.sw-option-choose').forEach(disableButton);
      if (badge.textContent.indexOf('Locked') === -1) badge.textContent += ' · Locked';
    });
  }

  function lockDoubleProtein(scope) {
    (scope || document).querySelectorAll('.sw-variant-option').forEach(function (option) {
      var label = option.querySelector('.sw-variant-option-label');
      if (!label || !/(double\s*protein|\+\$)/i.test(String(label.textContent || ''))) return;
      option.classList.add('sk-paid-locked-option');
      option.querySelectorAll('button').forEach(disableButton);
      if (!option.querySelector('.sk-paid-inline-note')) {
        var note = document.createElement('span');
        note.className = 'sk-paid-inline-note';
        note.textContent = 'Locked for this paid box';
        label.appendChild(note);
      }
    });
  }

  function lockAddOns() {
    var section = document.getElementById('sw-addon-section');
    if (!section || section.hidden) return;
    section.querySelectorAll('#sw-addon-grid .sw-addon-choice').forEach(function (choice) {
      choice.classList.add('sk-paid-locked-choice');
      choice.querySelectorAll('button').forEach(disableButton);
    });
    if (!document.getElementById('sk-addon-paid-lock-note')) {
      var intro = section.querySelector('.sw-addon-intro');
      if (intro && intro.parentNode) {
        var note = document.createElement('div');
        note.id = 'sk-addon-paid-lock-note';
        note.textContent = 'Your current extras are shown below, but paid extras are locked for this already-paid box. You can change them with your next weekly box.';
        intro.parentNode.insertBefore(note, intro.nextSibling);
      }
    }
  }

  function lockSelectionLists() {
    var names = premiumMealNames();
    document.querySelectorAll('#sw-sb-body .sw-sb-item,#sw-sheet-items .sw-sb-item').forEach(function (item) {
      var nameNode = item.querySelector('.sw-sb-name');
      var variantNode = item.querySelector('.sw-sb-variant');
      var name = String(nameNode && nameNode.textContent || '').trim();
      var variant = String(variantNode && variantNode.textContent || '');
      var paid = names.indexOf(name) !== -1 || /(double\s*protein|\+\$)/i.test(variant);
      if (!paid) return;
      item.classList.add('sk-paid-sidebar-item');
      disableButton(item.querySelector('.sw-sb-rm'));
    });
  }

  function lockModal() {
    var modal = document.getElementById('sw-meal-modal');
    if (!modal || !modal.classList.contains('open')) return;
    lockDoubleProtein(modal);
    var title = document.getElementById('sw-modal-title');
    var name = String(title && title.textContent || '').trim();
    if (premiumMealNames().indexOf(name) !== -1) {
      modal.querySelectorAll('#sw-modal-selection button').forEach(disableButton);
      var selection = document.getElementById('sw-modal-selection');
      if (selection && !selection.querySelector('.sk-paid-modal-note')) {
        var note = document.createElement('div');
        note.className = 'sk-paid-inline-note sk-paid-modal-note';
        note.textContent = 'This paid premium meal is locked for your first box.';
        selection.appendChild(note);
      }
    }
  }

  function applyLocks() {
    if (!locked) return;
    ensureBanner();
    lockPremiumCards();
    lockDoubleProtein(document);
    lockAddOns();
    lockSelectionLists();
    lockModal();
  }

  function observe(id, attributes) {
    var node = document.getElementById(id);
    if (!node || typeof MutationObserver !== 'function') return;
    var options = { childList: true, subtree: true, characterData: true };
    if (attributes) {
      options.attributes = true;
      options.attributeFilter = ['class'];
    }
    new MutationObserver(function () {
      window.setTimeout(applyLocks, 0);
    }).observe(node, options);
  }

  function installObservers() {
    if (installed) return;
    installed = true;
    observe('sw-meal-grid', false);
    observe('sw-addon-grid', false);
    observe('sw-sb-body', false);
    observe('sw-sheet-items', false);
    observe('sw-meal-modal', true);
  }

  function loadState() {
    window.fetch(STATE_URL, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load paid-box state');
      return response.json();
    }).then(function (data) {
      if (!data || data.paidChangesLocked !== true) return;
      locked = true;
      document.documentElement.setAttribute('data-sk-paid-changes-locked', 'true');
      addStyles();
      installObservers();
      applyLocks();
    }).catch(function () {
      /* Fail open in the UI. The server-side POST guard remains the source of truth. */
    });
  }

  function run() {
    if (!/\/pages\/subscribe\/?$/.test(window.location.pathname)) return;
    loadState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
